<template>
    <div
        class="summary__right"
        v-if="deliveryDetailsType !== FX_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN"
    >
        <section class="detail stock-type">
            <h3 class="section__heading">Delivery</h3>
            <template v-if="order.event.is_guest_list">
                <ul>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-ticket-2"></span>
                            <span><strong>{{ billingAddress.first_name }} {{ billingAddress.last_name }}</strong> will be added to the guest list once your order is confirmed.</span>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="FX_STOCK_TYPE_DELIVERY_METHOD.ELECTRONIC_OR_INSTANT === deliveryDetailsType">
                <ul>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>e-Tickets will be emailed to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-print-ticket"></span>
                            <span>Barcode tickets must be printed to enter the venue</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>QR Code tickets must be displayed on a mobile device</span>
                        </div>
                    </li>
                </ul>
                <div v-if="order.current_status === ORDER_STATUS.SENT_TO_BUYER"
                    class="ticket-download"
                >
                    <template v-if="hasTicketEmailDownload">
                        <span class="button">
                            <a class="ticket-download__action order__action"
                                target="_blank"
                                :href="order.ticket.fulfillment.links[0]"
                            >
                                Download
                            </a>
                        </span>
                    </template>
                    <template v-if="hasTicketPdfDownload">
                        <span class="button">
                            <a class="ticket-download__action order__action"
                                target="_blank"
                                :href="order.ticket.fulfillment.pdf.url"
                            >
                                Download
                            </a>
                        </span>
                    </template>
                </div>
            </template>
            <template v-else-if="FX_STOCK_TYPE_DELIVERY_METHOD.FLASH === deliveryDetailsType">
                <ul>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-alert"></span>
                            <span>If you do not have a AXS Mobile ID (formerly Flash Seats&reg;) account, sign up on <a href="https://axs.com" target="_blank">axs.com</a> using email address {{ order.customer.email_address }}</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-ticket-2"></span>
                            <span>Tickets will be transferred to your AXS Mobile ID account</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>Display tickets in the AXS Mobile ID App for entry</span>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="FX_STOCK_TYPE_DELIVERY_METHOD.HARD === deliveryDetailsType">
                <ul>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-truck"></span>
                            <span>
                            <template v-if="shippingAddress">
                                Physical tickets will be priority shipped by courier to:
                                <br>
                                <ShippingAddress :shipping-address="shippingAddress" />
                            </template>
                            <template v-else>
                                Physical tickets will be priority shipped by courier
                            </template>
                            </span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>A tracking number will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-ticket-2"></span>
                            <span>At the venue, present your tickets for entry</span>
                        </div>
                    </li>
                </ul>
                <div v-if="hasTicketTrackingNumber" class="tracking-information">
                    <h3 class="tracking-information__header">Tracking Number</h3>
                    <div class="tracking-information__tracking_number"><span v-html="order.ticket.delivery_method"></span> #{{ order.ticket.fulfillment.tracking.number }} </div>
                    <a
                        class="order__action"
                        target="_blank"
                        :href="order.ticket.fulfillment.tracking.url">
                            Track My Order
                    </a>
                </div>
            </template>
            <template v-else-if="FX_STOCK_TYPE_DELIVERY_METHOD.LAST_MINUTE === deliveryDetailsType">
                <ul>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-location-marker"></span>
                            <span>Tickets will be available for pick-up at/near the venue</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Location details and contact information will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="FX_STOCK_TYPE_DELIVERY_METHOD.MOBILE === deliveryDetailsType">
                <ul>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Mobile tickets will be transferred to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-ticket-2"></span>
                            <span>Follow the instructions to register and access your tickets</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>You must display tickets on a mobile device for entry</span>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="FX_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS === deliveryDetailsType">
                <ul>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-truck"></span>
                            <span>
	                            <template v-if="shippingAddress">
        	                        Paperless tickets will be loaded onto a digital card and shipped to:
                	                <br>
                        	        <ShippingAddress :shipping-address="shippingAddress" />
	                            </template>
        	                    <template v-else>
                	                Paperless tickets will be loaded onto a digital card and shipped by courier
                        	    </template>
                            </span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>A tracking number will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-cards"></span>
                            <span>At the venue, present or swipe the digital card for entry</span>
                        </div>
                    </li>
                </ul>
            </template>
        </section>

        <section
            class="detail"
            v-if="deliveryDate"
        >
            <h3 class="detail__heading">Expected Delivery</h3>
            <p class="detail__body">{{ deliveryDate | date }}</p>
        </section>
    </div>
</template>


<script>
import { ORDER_STATUS } from '../constants.js'
import { isDisplayInHandDate } from 'core/services/OrderService.js'
import { isInstantDelivery, isCourieredDelivery, INSTANT_DELIVERY_TYPES, TICKETMASTER_DELIVERY_TYPES } from 'core/utilities/DeliveryUtils'
import { FX_TICKET_STOCK_TYPES, HARD_TICKET_DELIVERY_TYPES} from '../enums'
import DateUtil from 'core/utilities/DateUtil'
import ShippingAddress from '../components/OrderCardShippingAddress'

const FX_STOCK_TYPE_DELIVERY_METHOD = {
    UNKNOWN: '',
    ELECTRONIC_OR_INSTANT: 'electronic-or-instant',
    FLASH: 'flash',
    HARD: 'hard',
    LAST_MINUTE: 'last-minute',
    MOBILE: 'mobile',
    PAPERLESS: 'paperless'
}

export default {
    beforeCreate () {
        this.FX_STOCK_TYPE_DELIVERY_METHOD = FX_STOCK_TYPE_DELIVERY_METHOD
        this.ORDER_STATUS = ORDER_STATUS
    },
    components: {
        ShippingAddress,
    },
    computed: {
        billingAddress () {
            return ((this.order || {}).customer || {}).billing_address || null
        },
        deliveryDate () {
            const deliveryDate = (((this.order || {}).ticket || {}).fulfillment || {}).estimated_delivery_date || null
            const isDisplayDeliveryDate = Boolean(deliveryDate) && isDisplayInHandDate(
                deliveryDate,
                this.order.date,
                this.order.event.local_date,
                this.order.ticket.stock_type.key,
                this.order.ticket.fulfillment.is_last_minute_local_delivery,
                this.order.event.is_lmlp
            )

            return isDisplayDeliveryDate ? deliveryDate : null
        },
        deliveryDetailsType () {
            if (!this.order) { return FX_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN }

            if (!(this.order.ticket && this.order.ticket.stock_type)) {
                console.error('Order is missing ticket or ticket.stock_type')
                return FX_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN
            }

            const ticketStockType = this.order.ticket.stock_type.key
            const isLastMinuteLocalDelivery = Boolean(this.order && this.order.ticket.fulfillment.is_last_minute_local_delivery)
            const isLastMinuteLocalPickup = Boolean(this.order && this.order.event.is_lmlp)
            let deliveryDetailsType = FX_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN

            if (isLastMinuteLocalDelivery || isLastMinuteLocalPickup) {
                deliveryDetailsType = FX_STOCK_TYPE_DELIVERY_METHOD.LAST_MINUTE
            } else {
                switch (ticketStockType) {
                case FX_TICKET_STOCK_TYPES.ELECTRONIC:
                    deliveryDetailsType = FX_STOCK_TYPE_DELIVERY_METHOD.ELECTRONIC_OR_INSTANT
                    break
                case FX_TICKET_STOCK_TYPES.FLASH:
                    deliveryDetailsType = FX_STOCK_TYPE_DELIVERY_METHOD.FLASH
                    break
                case FX_TICKET_STOCK_TYPES.HARD:
                    deliveryDetailsType = FX_STOCK_TYPE_DELIVERY_METHOD.HARD
                    break
                case FX_TICKET_STOCK_TYPES.INSTANT:
                    deliveryDetailsType = FX_STOCK_TYPE_DELIVERY_METHOD.ELECTRONIC_OR_INSTANT
                    break
                case FX_TICKET_STOCK_TYPES.MOBILE:
                    deliveryDetailsType = FX_STOCK_TYPE_DELIVERY_METHOD.MOBILE
                    break
                case FX_TICKET_STOCK_TYPES.PAPERLESS:
                    deliveryDetailsType = FX_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS
                    break
                default:
                    console.error(`Unkown Ticket Stock Type: ${ticketStockType}`)
                }
            }

            return deliveryDetailsType
        },
        shippingAddress () {
            if (!(this.order && this.order.customer && this.order.customer.shipping_address)) { return null }
            return this.order.customer.shipping_address
        },
        hasTicketEmailDownload () {
            return this.order.ticket.fulfillment.type === 'EMAIL' && this.order.ticket.fulfillment.links.length
        },
        hasTicketPdfDownload () {
            return (this.order.ticket.fulfillment.type === 'PDF' || this.order.ticket.fulfillment.type === 'QR') && (this.order.ticket.fulfillment.pdf || {}).url
        },
        hasTicketTrackingNumber () {
            return (this.order.ticket.fulfillment.tracking || {}).number &&
                (this.order.ticket.fulfillment.tracking || {}).url &&
                this.order.ticket.fulfillment.type === 'SHIP'
        }
    },
    filters: {
        date (value, format = 'MMM D, YYYY') {
            return DateUtil.format(value, format)
        }
    },
    props: {
        order: {
            required: true,
            type: Object
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

div.ticket-download span.button {
    background-color: var(--c-checkout-btn-bg);
}

.button {
    background-color: var(--c-checkout-btn-bg);
    border: var(--c-checkout-btn-bg) solid 1px;
    color: white;
    background: var(--c-checkout-btn-bg);
    padding: 6px 16px;
    transition: 0.2s ease;
    white-space: nowrap;
    background: #1c74a5;

    &:hover,
    &:focus {
        color: white;
        cursor: pointer;
        transition: 0.2s ease;
    }
}
.ticket-download {
    margin-top: 22px;
}

.ticket-download span a {
    color: white;
}

.display-flex {
    display: flex
}
div.display-flex span {
    display: block
}
div.display-flex span.stock-type__icon {
    margin-right: 8px;
}
ul.delivery-details:first-child {
    margin-top: 4px;
}

li.stock-type__item {
  margin-bottom: 10px;
}

</style>
